import React, { useState, useEffect } from "react";
import { query, where, collection, getDocs, doc, getDoc, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase.js";
import Cookies from "js-cookie";
import QRCode from "../../components_root/QRCode.jsx";
import Bar_code from "../../components_root/bar_code.js";
import { data } from "react-router-dom";
import AmountToWords from "../../components_root/AmountToWords.js";

export default function Print_receipt_a4({ voucherprintid, printid }) {
    const [voucherdata, setVoucherdata] = useState(null);
    const [voucheritemsdata, setVoucheritemsdata] = useState([]);
    const [companydata, setCompanydata] = useState([]);
    const [readyToPrint, setReadyToPrint] = useState(false);
    const servicetablename = "accountingfinancedb";
    const [printdata, setPrintdata] = useState([]);
    const [select_company_uid, setselect_company_uid] = useState(null);
    const [stockdata, setStockdata] = useState([]);
    // Fetch voucher
    useEffect(() => {
        const fetchVoucher = async () => {
            if (!voucherprintid) return;
            const select_company_uid = Cookies.get("select_company_uid");
            setselect_company_uid(select_company_uid);
            if (!select_company_uid) return;

            const q = query(
                collection(db, servicetablename, select_company_uid, "voucher_print"),
                where("voucherprintid", "==", voucherprintid)
            );
            const snap = await getDocs(q);
            const data = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
            setVoucherdata(data[0] || null);
        };

        fetchVoucher();
    }, [!voucherprintid]);
    //stock
    useEffect(() => {
        const fetchVoucher = async () => {
            if (!voucherprintid) return;
            const select_company_uid = Cookies.get("select_company_uid");
            setselect_company_uid(select_company_uid);
            if (!select_company_uid) return;

            const q = query(
                collection(db, servicetablename, select_company_uid, "voucher_print_stock"),
                where("voucherprintid", "==", voucherprintid)
            );
            const snap = await getDocs(q);
            const data = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
            setStockdata(data || null);
        };

        fetchVoucher();
    }, [!voucherprintid]);
    // Load print settings
    useEffect(() => {
        if (!select_company_uid) return;

        const q = query(
            collection(db, servicetablename, select_company_uid, "print_setting"), where("printid", "==", printid)
        );

        const unsub = onSnapshot(q, (snapshot) => {
            const data = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));

            const settingArray = data[0]?.settingdata || [];

            // convert back to object
            const settingObj = Object.fromEntries(
                settingArray.map(item => [item.key, item.value])
            );

            setPrintdata(settingObj);
        });

        return () => unsub();
    }, [select_company_uid]);
    useEffect(() => {
        const fetchVoucher = async () => {
            if (!voucherprintid) return;

            const select_company_uid = Cookies.get("select_company_uid");
            if (!select_company_uid) return;

            const docRef = doc(db, servicetablename, select_company_uid);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                setCompanydata({
                    id: docSnap.id,
                    ...docSnap.data()
                });
            } else {
                setCompanydata(null);
            }
        };

        fetchVoucher();
    }, [voucherprintid]);



    useEffect(() => {
        if (readyToPrint == true && voucherdata) {
            printNow();
        }
    }, [readyToPrint, voucherdata]);
    // Auto print after voucher loads
    // <title>Receipt-${voucherprintid}</title>
    const fileManagerItems = voucherdata?.filemanager
        ? Object.values(voucherdata.filemanager)
        : [];
    const FIELD_ORDER = ["title", "filenumber", "issue_date", "expiry_date"];
    const FIELD_LABELS = {
        filenumber: "File No",
        issue_date: "Issue Date",
        expiry_date: "Expiry Date"
    };
    const printNow = () => {
        const area = document.getElementById("print-area");
        if (!area) return;

        const content = area.innerHTML;
        const printWindow = window.open("", "", "width=800,height=600");

        printWindow.document.open();
        printWindow.document.write(`
            <html>
                <head>
                    <title>Receipt-${voucherprintid}</title>
                    <style>
    @page {
        size: A4;
        margin: 10mm;
    }

    body {
        font-family: Arial, sans-serif;
        margin: 0;
        padding: 0;
    }

    .a4-page {
        width: 210mm;
        min-height: 297mm;
        padding: 10mm;
        box-sizing: border-box;
        page-break-after: always;
    }

    .a4-page:last-child {
        page-break-after: auto;
    }

    .bold { font-weight: bold; }

    .line-top {
        border-top: 1px solid #000;
     
    }
    
      .line-top2 {
        border-top: 2px solid #000;
        
    }
           .line1 {
        border-top: 1px solid #000;
        margin: 5px 0;
    }
    .line-bottom{
        border-bottom: 1px solid #000; 
    }
   
           .line-left {
       border-left: 1px solid #000;
        margin: 5px 0;
    } 
              .line-right {
       border-right: 1px solid #000;
        margin: 5px 0;
    }      
 
.rounded {
  border-radius: 6px !important;
  
}
  .p-top
  {  margin: 3px 0px 0px 0px !important;
  }
  .p-1 {
  padding: 2px 4px !important;
}
  .box-line{
    border: 1px solid #000;
  }
 .items-back-fill {
  border: 1px solid #000; 
}
    table {
        width: 100%;
        border-collapse: collapse;
        font-size: 14px;
    }

    td {
        padding: 2px;
        vertical-align: top;
    }

    .center { text-align: center; }
    .cap { text-transform: uppercase; }
    .fcap { text-transform: capitalize; }

    .title {
        font-size: 22px;
        font-weight: bold;
        text-align: center;
    }

    .title_sub {
        font-size: 18px;
        font-weight: bold;
    }

    .header-text {
        font-size: 14px;
    }

    .description-text {
        font-size: 14px;
    }

    .amount-text {
        text-align: right;
        font-weight: 600;
    }

    .footer-text {
        text-align: center;
        font-weight: bold;
        font-size: 18px; 
    }
  .barcode  {
        text-align: center;
        
        width: 100%;
        height: 60px;
    }
    .barcode svg {
        width: 100%;
        height: 60px;
    }
.text-h1 {
  font-size: 14px !important;
}
.flex {
   display: flex !important;
}
.text-h2 {
  font-size: 12px !important;
}

.text-h3 {
  font-size: 10px !important;
}

.text-h4 {
  font-size: 9px !important;
}

.text-h5 {
  font-size: 8px !important;
}
    /* Prevent row breaking */
    tr { page-break-inside: avoid; }

</style>

                </head>
                <body>${content}</body>
            </html>
        `);
        printWindow.document.close();

        // printWindow.onload = () => {
        //     printWindow.focus();
        //     printWindow.print(); 
        //     printWindow.close();
        // }; 
        printWindow.onload = () => {
            printWindow.focus();
            if (window?.require) {
                // Electron renderer (optional bridge)
                window.electron.printSilent();
            } else {
                // Browser fallback
                printWindow.print();
            }

            printWindow.close();
        };
    };

    if (!voucherdata) return null;
    const domain = new URL(window.location.href).hostname;
    return (
        <div >
            <div
                id="print-area"
                style={{
                    visibility: "hidden",
                    position: "absolute",
                    left: "-9999px",
                }}
            >

                <div className="p-1"  >
                    <table>
                        <tr>
                            <td>
                                <div className="title_sub bold">
                                    {printdata.print_title}
                                </div>
                                <div className="text-h2 bold">
                                    {printdata.print_tagline || ""}
                                </div>
                                <div className="text-h3 bold">
                                    {printdata.print_contactinfo || ""}
                                </div>
                                <div className="text-h3 bold">
                                    {printdata.print_address || ""}
                                </div>
                            </td>
                            <td width={55}>
                                <QRCode
                                    url={domain + "/" + voucherdata.slug}
                                    size={50}
                                    onReady={() => setReadyToPrint(true)}
                                />
                                <div className="text-h2 center bold">Aooz.in</div>
                            </td>
                        </tr>
                    </table>
                </div>
                <div className="items-back-fill" >
                    <div className="p-1   line-bottom"  >
                        <table>
                            <tr>
                                <td className="text-hl" width={130}><a className="bold">Token: {voucherdata.tokennumber}</a>

                                    <td  >
                                        <div className="text-h1 bold center">RECEIPT</div>
                                    </td>
                                    <td width={160} style={{ textAlign: "right" }}>
                                        {voucherdata.date_time?.toDate ? (
                                            <>
                                                {voucherdata.date_time.toDate().toLocaleDateString()}{" "}
                                                {voucherdata.date_time.toDate().toLocaleTimeString()}
                                            </>
                                        ) : (
                                            "No date"
                                        )}
                                        <br />
                                        <a className="text-h2 ">#{voucherdata.vouchernumber}</a></td>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div className="p-1"  >
                        <table>
                            <tr>
                                <td> <table>
                                    <tr>
                                        <td>
                                            <div className="text-h2 bold fcap">
                                                {voucherdata.namepaying || "Name n/a"}
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <div className="text-h2">
                                                {voucherdata.mobile || ""}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>

                                        <td>
                                            <div className="text-h3 fcap">
                                                {voucherdata.addresspaying || ""}
                                            </div>
                                        </td>
                                    </tr>

                                </table></td>
                                <td width={150}>
                                    <div className="barcode">
                                        <Bar_code value={voucherdata.vouchernumber} code={false} />
                                    </div>
                                </td>
                            </tr>
                        </table>

                    </div>
                    {/* fileManagerItems */}
                    <table className="text-h2">
                        <tbody>
                            {fileManagerItems.length > 0 &&
                                fileManagerItems.map((item, rowIndex) => (
                                    <tr key={rowIndex}>
                                        <td className="line1">
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        {/* TITLE */}
                                                        <td className="bold fcap text-h2">
                                                            {item.title || "Untitled"}
                                                        </td>

                                                        {/* FIXED ORDER FIELDS */}
                                                        {FIELD_ORDER
                                                            .filter(key => key !== "title" && key.length > 0)
                                                            .map((key) => (
                                                                <td
                                                                    key={key}
                                                                    style={{ textAlign: "right" }}
                                                                    className="fcap text-h2 p-11"
                                                                >
                                                                    <div className="text-off">
                                                                        {FIELD_LABELS[key] || ""}
                                                                    </div>
                                                                    <div className="bold">
                                                                        {item[key] || ""}
                                                                    </div>
                                                                </td>
                                                            ))}
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                    <div className="description-text line-top">
                        <table >
                            <tbody>
                                {stockdata.length > 0 &&
                                    stockdata.map((row, rowIndex) => (
                                        <div key={rowIndex}>

                                            {Array.isArray(row.items) &&
                                                row.items.map((item, index) => (
                                                    <tr key={index}>
                                                        <td className="line-right">
                                                            <table>
                                                                <tr>
                                                                    <td className="bold fcap text-h2">{item.title}</td>
                                                                    <td width={100} className="fcap text-h2">{item.itemname}</td>
                                                                    <td width={80}>
                                                                        <div >{item.perday ? "Per Day" : "Price"}</div> </td>

                                                                    <td width={70} className=" fcap text-h2 ">₹{item.price}</td>
                                                                    <td width={70} className=" fcap text-h2 ">₹{item.price} X {item.qty}</td>
                                                                </tr>
                                                            </table>
                                                        </td>

                                                        <td className="bold line-bottom text-r" style={{ textAlign: "right" }}>

                                                            {item.amount}/-

                                                        </td>



                                                    </tr>
                                                ))}

                                        </div>
                                    ))
                                }
                                {voucheritemsdata.length > 0 ? (
                                    voucherdata.items.map((item, index) => (
                                        <tr key={index}  >
                                            <td className="text-h2 bold p-1 fcap">{item.description || item.voucher}</td>

                                            <td className="amount-text p-1  line-left line-bottom">{item.amount}/-</td>
                                        </tr>


                                    ))
                                ) : (
                                    <tr>
                                        <td className="text-h2 p-1 fcap bold">{voucherdata.voucher}</td>
                                        <td className="bold line-left p-1 line-bottom" style={{ textAlign: "right" }}>{voucherdata.amount}/-</td>
                                    </tr>
                                )}
                                {voucherdata.ledger_manager_items &&
                                    voucherdata.ledger_manager_items.length > 0 && (
                                        voucherdata.ledger_manager_items
                                            .filter(item => item.account_type === "charges")
                                            .map((item, index) => (
                                                <tr key={index}>
                                                    <td className="text-h2 p-1 fcap">{item.managename || item.voucher}</td>
                                                    <td className="amount-text p-1  line-left line-bottom" style={{ textAlign: "right" }}>
                                                        {item.amount}/- {item.mathedcalc === "=" ? ("") : (item.mathedcalc)}
                                                    </td>
                                                </tr>
                                            ))
                                    )
                                }

                                {typeof voucherdata.eventdate?.toDate === "function" &&
                                    voucherdata.eventstatus === true && (
                                        <tr>
                                            <td className="text-h2 bold line-right">
                                                Event date:<br />
                                                {voucherdata.eventdate.toDate().toLocaleDateString()}{" "}
                                                {voucherdata.eventdate.toDate().toLocaleTimeString()}
                                            </td>
                                            <td></td>
                                        </tr>
                                    )}
                                {voucherdata.remarks != null && voucherdata.remarks.length > 0 && (
                                    <tr>
                                        <td className="text-h2 p-1 line-right">
                                            {voucherdata.refer_number != null && voucherdata.refer_number !== "" &&
                                                `Refer No.: ${voucherdata.refer_number}`}
                                        </td>
                                        <td > </td>
                                    </tr>
                                )}
                                {voucherdata.remarks != null && voucherdata.remarks.length > 0 && (
                                    <tr>
                                        <td className="text-h2 p-1 line-right fcap">{voucherdata.remarks || ""}</td>
                                        <td > </td>
                                    </tr>
                                )}

                                <tr className="line-top ">
                                    <td className="p-1 "><div className="text-h1 bold" >TOTAL AMOUNT </div>
                                        <a className="text-h3 ">
                                            <AmountToWords amount={voucherdata.totalamount} />
                                        </a>
                                    </td>
                                    <td className="line-left p-1" style={{ textAlign: "right" }}>
                                        <b className="text-h1 bold text-r">₹ {voucherdata.totalamount}/-</b>
                                        <br />
                                        <div className="flex fill" style={{ textAlign: "right" }}>
                                             {voucherdata.payment_method_online ? <div className="text-h3" >Pay: Online</div> : <div className="text-h3">Pay: Cash</div>}
                                            </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>

                </div>     <div className="p-1">
                    <table>
                        <tr>
                            <td className="p-1"> <div className="text-h4 ">
                                {printdata.print_trams_footer || ""}
                            </div>
                                <div className="text-h3 bold">
                                    {printdata.print_contact_info_footer || ""}
                                </div>
                                <div className="text-h3 bold">
                                    {printdata.print_address_footer || ""}
                                </div>

                            </td>
                            <td style={{ textAlign: "right" }}>{new Date().toLocaleString()}</td>
                        </tr>
                        <tr>
                            <td> <div className="text-h2 bold p-1">THANK YOU</div></td>
                            <td
                                style={{
                                    textAlign: "right",
                                    paddingTop: "15px",
                                    fontSize: "12px"
                                }}
                            >
                                <div style={{ borderTop: "1px solid #000", width: "150px", marginLeft: "auto" }}></div>
                                Authority Signature
                            </td>
                        </tr>
                    </table>
                </div>


            </div>
        </div>
    );
}
